<template>
  <div class="dati-checkin" v-if="!isFetching">
    <div style="clear: both"></div>
    <br />
    <div v-if="nome_file_logo != ''">
      <b-img
        :src="nome_file_logo"
        fluid-grow
        alt="Logo strutture"
        style="max-height: 152px"
      ></b-img>
      <br />
      <br />
    </div>
    <b-row style="text-align: right">
      <b-col lg="2" xl="2"> </b-col>
      <b-col md="6" lg="5" xl="5">
        {{ labels.numero_prenotazione }}:
        <strong>{{ local_reservation.reservation_code }}</strong>
      </b-col>
      <b-col md="6" lg="5" xl="5">
        {{ labels.periodo_soggiorno }}:
        <strong
          >{{ drizzaData(new Date(local_reservation.inizio_soggiorno)) }} -
          {{ drizzaData(new Date(local_reservation.fine_soggiorno)) }}</strong
        >
      </b-col>
    </b-row>

    <br />

    <div style="float: left" v-if="!riepilogo_dati">
      <h2>{{ labels.inserire_i_dati_richiesti }}</h2>
    </div>
    <div style="float: left" v-else>
      <h2>{{ labels.controllare_i_dati_inseriti }}</h2>
    </div>
    <Lingua style="float: right"></Lingua>
    <div style="clear: both"></div>

    <div v-for="(persona, index) in local_reservation.persone" :key="index">
      <br />
      <h3 v-if="index == 0">1) {{ labels.capofamiglia }}</h3>
      <h3 v-else>{{ index + 1 }}) {{ labels.partecipante }}</h3>

      <b-form-row class="b-form-row">
        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.cognome">
            <b-form-input
              :size="size"
              class="b-form-input"
              :id="'cognome' + index"
              :value="persona.cognome"
              @change="persona.cognome = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-cognome' + index"
              v-if="errori[index] != undefined && errori[index].cognome != ''"
            >
              {{ labels_errori[errori[index].cognome] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.nome">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'nome' + index"
              :value="persona.nome"
              @change="persona.nome = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-nome' + index"
              v-if="errori[index] != undefined && errori[index].nome != ''"
            >
              {{ labels_errori[errori[index].nome] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col xs="4" sm="2" md="2" lg="1" xl="1">
          <b-form-group
            v-bind:label="labels.sesso"
            v-bind:disabled="riepilogo_dati"
          >
            <input type="radio" value="M" v-model="persona.sesso" />
            <label style="margin: 0">{{
              valori_sesso.find((s) => s.value == "M").text
            }}</label>
            <br />
            <input type="radio" value="F" v-model="persona.sesso" />
            <label style="margin: 0">{{
              valori_sesso.find((s) => s.value == "F").text
            }}</label>
            <p
              class="errore"
              :id="'errore-sesso' + index"
              v-if="errori[index] != undefined && errori[index].sesso != ''"
            >
              {{ labels_errori[errori[index].sesso] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col xs="6" sm="5" md="4" lg="2" xl="2">
          <b-form-group v-bind:label="labels.cittadinanza">
            <b-form-select
              size="sm"
              class="b-form-select"
              :value="persona.cittadinanza"
              @change="persona.cittadinanza = $event"
              v-bind:disabled="riepilogo_dati"
              :options="countries"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-cittadinanza' + index"
              v-if="
                errori[index] != undefined && errori[index].cittadinanza != ''
              "
            >
              {{ labels_errori[errori[index].cittadinanza] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="5" md="6" lg="3" xl="3" v-if="persona.cittadinanza == 'IT'">
          <b-form-group v-bind:label="labels.codice_fiscale">
            <b-form-input
              size="sm"
              style="text-transform: uppercase"
              class="b-form-input"
              :id="'codice-fiscale' + index"
              :value="persona.codice_fiscale"
              @change="persona.codice_fiscale = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="16"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-codice-fiscale' + index"
              v-if="
                errori[index] != undefined && errori[index].codice_fiscale != ''
              "
            >
              {{ labels_errori[errori[index].codice_fiscale] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.nazione_residenza">
            <b-form-select
              size="sm"
              class="b-form-select"
              :value="persona.nazione_residenza"
              @change="persona.nazione_residenza = $event"
              v-bind:disabled="riepilogo_dati"
              :options="countries"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-nazione-residenza' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].nazione_residenza != ''
              "
            >
              {{ labels_errori[errori[index].nazione_residenza] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.localita_residenza">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'localita-residenza' + index"
              :name="'localita-residenza' + index"
              :value="persona.localita_residenza"
              @change="persona.localita_residenza = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
              autocomplete="off"
              v-on:input="localita_variata('R', index, $event)"
              list="autocomplete-localita-residenza"
            ></b-form-input>

            <datalist id="autocomplete-localita-residenza">
              <option
                v-for="localita in lista_localita_residenza"
                :key="localita"
              >
                {{ localita }}
              </option>
            </datalist>

            <p
              class="errore"
              :id="'errore-localita-residenza' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].localita_residenza != ''
              "
            >
              {{ labels_errori[errori[index].localita_residenza] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="5" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.indirizzo_residenza">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'indirizzo-residenza' + index"
              :value="persona.indirizzo_residenza"
              @change="persona.indirizzo_residenza = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
              autocomplete="off"
            ></b-form-input>

            <!--
              v-on:input="indirizzo_variato(index)"
              list="autocomplete-indirizzo-residenza"
            <datalist id="autocomplete-indirizzo-residenza">
              <option
                v-for="indirizzo in lista_indirizzi_residenza"
                :key="indirizzo"
              >{{ indirizzo }}</option>
            </datalist>-->

            <p
              class="errore"
              :id="'errore-indirizzo-residenza' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].indirizzo_residenza != ''
              "
            >
              {{ labels_errori[errori[index].indirizzo_residenza] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="7" md="6" lg="3" xl="3">
          <div style="float: left; width: 38%; margin-right: 10px">
            <b-form-group v-bind:label="labels.civico_residenza">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'civico-residenza' + index"
                :value="persona.civico_residenza"
                @change="persona.civico_residenza = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="15"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-civico-residenza' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].civico_residenza != ''
                "
              >
                {{ labels_errori[errori[index].civico_residenza] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 23%; margin-right: 10px">
            <b-form-group v-bind:label="labels.provincia_residenza">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'provincia-residenza' + index"
                :value="persona.provincia_residenza"
                @change="persona.provincia_residenza = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="2"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-provincia-residenza' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].provincia_residenza != ''
                "
              >
                {{ labels_errori[errori[index].provincia_residenza] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 29%">
            <b-form-group v-bind:label="labels.cap_residenza">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'cap-residenza' + index"
                :value="persona.cap_residenza"
                @change="persona.cap_residenza = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="5"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-cap-residenza' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].cap_residenza != ''
                "
              >
                {{ labels_errori[errori[index].cap_residenza] }}
              </p>
            </b-form-group>
          </div>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col cols="12">{{ labels.data_nascita }}</b-col>
      </b-form-row>
      <b-form-row class="b-form-row">
        <b-col sm="6" md="6" lg="3" xl="3">
          <div style="float: left; width: 25%; margin-right: 10px">
            <b-form-group v-bind:label="labels.giorno_nascita">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'giorno-nascita' + index"
                :value="persona.giorno_nascita"
                @change="persona.giorno_nascita = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="2"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-giorno-nascita' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].giorno_nascita != ''
                "
              >
                {{ labels_errori[errori[index].giorno_nascita] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 25%; margin-right: 10px">
            <b-form-group v-bind:label="labels.mese_nascita">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'mese-nascita' + index"
                :value="persona.mese_nascita"
                @change="persona.mese_nascita = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="2"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-mese-nascita' + index"
                v-if="
                  errori[index] != undefined && errori[index].mese_nascita != ''
                "
              >
                {{ labels_errori[errori[index].mese_nascita] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 35%">
            <b-form-group v-bind:label="labels.anno_nascita">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'anno-nascita' + index"
                :value="persona.anno_nascita"
                @change="persona.anno_nascita = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="4"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-anno-nascita' + index"
                v-if="
                  errori[index] != undefined && errori[index].anno_nascita != ''
                "
              >
                {{ labels_errori[errori[index].anno_nascita] }}
              </p>
            </b-form-group>
          </div>
        </b-col>

        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.nazione_nascita">
            <b-form-select
              size="sm"
              class="b-form-select"
              :value="persona.nazione_nascita"
              @change="persona.nazione_nascita = $event"
              v-bind:disabled="riepilogo_dati"
              :options="countries"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-nazione-nascita' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].nazione_nascita != ''
              "
            >
              {{ labels_errori[errori[index].nazione_nascita] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="6" lg="3" xl="3">
          <b-form-group v-bind:label="labels.comune_nascita">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'comune-nascita' + index"
              :value="persona.comune_nascita"
              @change="persona.comune_nascita = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
              autocomplete="off"
              list="autocomplete-comune-nascita"
              v-on:input="localita_variata('N', index, $event)"
            ></b-form-input>

            <datalist id="autocomplete-comune-nascita">
              <option
                v-for="localita in lista_localita_nascita"
                :key="localita"
              >
                {{ localita }}
              </option>
            </datalist>

            <p
              class="errore"
              :id="'errore-comune-nascita' + index"
              v-if="
                errori[index] != undefined && errori[index].comune_nascita != ''
              "
            >
              {{ labels_errori[errori[index].comune_nascita] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col xs="4" sm="4" md="2" lg="1" xl="1">
          <b-form-group v-bind:label="labels.provincia_nascita">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'provincia-nascita' + index"
              :value="persona.provincia_nascita"
              @change="persona.provincia_nascita = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="2"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-provincia-nascita' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].provincia_nascita != ''
              "
            >
              {{ labels_errori[errori[index].provincia_nascita] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col
          xs="8"
          sm="5"
          md="4"
          lg="2"
          xl="2"
          v-if="local_reservation.presenza_viaggio == 'S'"
        >
          <b-form-group v-bind:label="labels.partecipazione_viaggio">
            <b-form-select
              size="sm"
              :id="'partecipazione-viaggio' + index"
              class="b-form-select"
              :value="persona.partecipazione_viaggio"
              @change="persona.partecipazione_viaggio = $event"
              v-bind:disabled="riepilogo_dati"
              :options="valori_partecipazione_viaggio"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-partecipazione-viaggio' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].partecipazione_viaggio != ''
              "
            >
              {{ labels_errori[errori[index].partecipazione_viaggio] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row class="b-form-row">
        <b-col sm="6" md="6" lg="3" xl="3">
          <div class="d-none d-sm-none d-lg-block">
            <p></p>
          </div>
          <b-form-group v-bind:label="labels.tipo_documento_identita">
            <b-form-select
              size="sm"
              :id="'tipo-documento-identita' + index"
              class="b-form-select"
              :value="persona.tipo_documento_identita"
              @change="persona.tipo_documento_identita = $event"
              v-bind:disabled="riepilogo_dati"
              :options="tipi_documento"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-tipo-documento-indentita' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].tipo_documento_identita != ''
              "
            >
              {{ labels_errori[errori[index].tipo_documento_identita] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="6" lg="3" xl="3">
          <div class="d-none d-sm-none d-lg-block">
            <p></p>
          </div>
          <b-form-group v-bind:label="labels.ente_rilascio">
            <b-form-select
              size="sm"
              :id="'ente-rilascio' + index"
              class="b-form-select"
              :value="persona.ente_rilascio"
              @change="persona.ente_rilascio = $event"
              v-bind:disabled="riepilogo_dati"
              :options="enti_rilascio"
              :plain="$store.state.SelectPlain"
            ></b-form-select>
            <p
              class="errore"
              :id="'errore-ente-rilascio' + index"
              v-if="
                errori[index] != undefined && errori[index].ente_rilascio != ''
              "
            >
              {{ labels_errori[errori[index].ente_rilascio] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col sm="4" md="4" lg="2" xl="2">
          <div style="margin-top: -4px">{{ labels.data_rilascio }}</div>
          <div style="float: left; width: 25%; margin-right: 10px">
            <b-form-group v-bind:label="labels.giorno_rilascio">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'giorno-rilascio' + index"
                :value="persona.giorno_rilascio"
                @change="persona.giorno_rilascio = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="2"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-giorno-rilascio' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].giorno_rilascio != ''
                "
              >
                {{ labels_errori[errori[index].giorno_rilascio] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 25%; margin-right: 10px">
            <b-form-group v-bind:label="labels.mese_rilascio">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'mese-rilascio' + index"
                :value="persona.mese_rilascio"
                @change="persona.mese_rilascio = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="2"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-mese-rilascio' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].mese_rilascio != ''
                "
              >
                {{ labels_errori[errori[index].mese_rilascio] }}
              </p>
            </b-form-group>
          </div>
          <div style="float: left; width: 35%">
            <b-form-group v-bind:label="labels.anno_rilascio">
              <b-form-input
                size="sm"
                class="b-form-input"
                :id="'anno-rilascio' + index"
                :value="persona.anno_rilascio"
                @change="persona.anno_rilascio = $event"
                v-bind:readonly="riepilogo_dati"
                maxlength="4"
              ></b-form-input>
              <p
                class="errore"
                :id="'errore-anno-rilascio' + index"
                v-if="
                  errori[index] != undefined &&
                  errori[index].anno_rilascio != ''
                "
              >
                {{ labels_errori[errori[index].anno_rilascio] }}
              </p>
            </b-form-group>
          </div>
        </b-col>

        <b-col sm="4" md="4" lg="2" xl="2">
          <div class="d-none d-sm-block">
            <p></p>
          </div>
          <b-form-group v-bind:label="labels.luogo_rilascio">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'luogo-rilascio' + index"
              :value="persona.luogo_rilascio"
              @change="persona.luogo_rilascio = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
              autocomplete="off"
              list="autocomplete-luogo-rilascio"
              v-on:input="localita_variata('D', index, $event)"
            ></b-form-input>

            <datalist id="autocomplete-luogo-rilascio">
              <option
                v-for="localita in lista_localita_rilascio"
                :key="localita"
              >
                {{ localita }}
              </option>
            </datalist>

            <p
              class="errore"
              :id="'errore-luogo-rilascio' + index"
              v-if="
                errori[index] != undefined && errori[index].luogo_rilascio != ''
              "
            >
              {{ labels_errori[errori[index].luogo_rilascio] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="4" md="4" lg="2" xl="2">
          <div class="d-none d-sm-block">
            <p></p>
          </div>
          <b-form-group v-bind:label="labels.numero_documento_identita">
            <b-form-input
              size="sm"
              class="b-form-input"
              :id="'numero-documento-identita' + index"
              :value="persona.numero_documento_identita"
              @change="persona.numero_documento_identita = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-numero-documento-identita' + index"
              v-if="
                errori[index] != undefined &&
                errori[index].numero_documento_identita != ''
              "
            >
              {{ labels_errori[errori[index].numero_documento_identita] }}
            </p>
          </b-form-group>
        </b-col>
      </b-form-row>

      <b-form-row style="margin-bottom: 8px">
        <b-col sm="6" md="3" lg="3" xl="3" v-if="index == 0">
          <b-form-group v-bind:label="labels.email">
            <b-form-input
              size="sm"
              type="email"
              class="b-form-input"
              id="email"
              :value="local_reservation.email"
              @change="local_reservation.email = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="100"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-email' + index"
              v-if="errori[index] != undefined && errori[index].email != ''"
            >
              {{ labels_errori[errori[index].email] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col sm="6" md="3" lg="3" xl="3" v-if="index == 0">
          <b-form-group v-bind:label="labels.cellulare">
            <b-form-input
              size="sm"
              class="b-form-input"
              id="cellulare"
              :value="local_reservation.cellulare"
              @change="local_reservation.cellulare = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
            <p
              class="errore"
              :id="'errore-cellulare' + index"
              v-if="errori[index] != undefined && errori[index].cellulare != ''"
            >
              {{ labels_errori[errori[index].cellulare] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col
          xs="12"
          sm="6"
          md="6"
          lg="2"
          xl="2"
          v-if="index == 0 && local_reservation.presenza_viaggio == 'S'"
        >
          <b-form-group v-bind:label="labels.targa_auto1">
            <b-form-input
              size="sm"
              class="b-form-input"
              id="targa-auto1"
              :value="local_reservation.targa_auto1"
              @change="local_reservation.targa_auto1 = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col
          xs="12"
          sm="6"
          md="6"
          lg="2"
          xl="2"
          v-if="index == 0 && local_reservation.presenza_viaggio == 'S'"
        >
          <b-form-group v-bind:label="labels.targa_auto2">
            <b-form-input
              size="sm"
              class="b-form-input"
              id="targa-auto2"
              :value="local_reservation.targa_auto2"
              @change="local_reservation.targa_auto2 = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col
          xs="12"
          sm="6"
          md="6"
          lg="2"
          xl="2"
          v-if="index == 0 && local_reservation.presenza_viaggio == 'S'"
        >
          <b-form-group v-bind:label="labels.targa_auto3">
            <b-form-input
              size="sm"
              class="b-form-input"
              id="targa-auto3"
              :value="local_reservation.targa_auto3"
              @change="local_reservation.targa_auto3 = $event"
              v-bind:readonly="riepilogo_dati"
              maxlength="45"
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-form-row>
    </div>
    <hr />

    <div style="padding-left: 20px; padding-right: 20px">
      <h3>{{ labels.privacy }}</h3>
      <p class="justified">{{ labels.la_informiamo }}</p>
      <p class="justified">
        {{ labels.il_trattamento }}
        <i>{{ riferimento_struttura }}</i>
        {{ labels.quale_titolare }}
      </p>

      <b-form-group :disabled="riepilogo_dati">
        <div>
          <input type="radio" value="S" v-model="local_reservation.privacy" />
          &nbsp;
          <label>{{ labels.do_il_consenso }}</label>
        </div>
        <div>
          <input type="radio" value="N" v-model="local_reservation.privacy" />
          &nbsp;
          <label>{{ labels.non_do_il_consenso }}</label>
        </div>
        <p
          class="errore"
          id="errore-privacy"
          v-if="errori[0] != undefined && errori[0].privacy != ''"
        >
          {{ labels_errori[errori[0].privacy] }}
        </p>
      </b-form-group>

      <p class="justified">{{ labels.i_suoi_dati }}</p>
      <b-form-group :disabled="riepilogo_dati">
        <div>
          <input
            type="radio"
            value="S"
            v-model="local_reservation.consenso_messaggi_pubblicitari"
          />
          &nbsp;
          <label>{{ labels.do_il_consenso }}</label>
        </div>
        <div>
          <input
            type="radio"
            value="N"
            v-model="local_reservation.consenso_messaggi_pubblicitari"
          />
          &nbsp;
          <label>{{ labels.non_do_il_consenso }}</label>
        </div>
        <p
          class="errore"
          id="errore-consenso-messaggi-pubblicitari"
          v-if="
            errori[0] != undefined &&
            errori[0].consenso_messaggi_pubblicitari != ''
          "
        >
          {{ labels_errori[errori[0].consenso_messaggi_pubblicitari] }}
        </p>
      </b-form-group>
    </div>
    <hr />

    <div style="padding-right: 20px; padding-left: 20px">
      <div v-if="riepilogo_dati">
        <p class="justified">
          {{
            labels.ricordiamo_ai_gentili_ospiti +
            reservation.select_struttura.telefono +
            labels.potrebbe_essere_applicato
          }}
        </p>
        <br />
        <b-form-checkbox
          id="conferma-verifica"
          v-model="conferma_verifica"
          name="conferma-verifica"
          value="S"
          unchecked-value="N"
        >
          <strong>{{ labels.confermo_che_i_dati_inseriti }}</strong>
        </b-form-checkbox>
        <br />
        <p
          class="errore"
          id="errore-conferma-verifica"
          v-if="errori[0] != undefined && errori[0].conferma_verifica != ''"
        >
          {{ labels_errori[errori[0].conferma_verifica] }}
        </p>
      </div>

      <div
        v-if="
          errori[0] != undefined &&
          errori[0].errore_generale != '' &&
          errori[0].errore_generale == 'anni_non_coincidenti'
        "
      >
        <p class="errore" id="errore-generale">
          {{ labels_errori[errori[0].errore_generale] }}:
          {{ local_reservation.numero_adulti }} {{ labels_errori.adulti }} -
          {{ local_reservation.numero_bambini }} {{ labels_errori.bambini }} -
          {{ local_reservation.numero_neonati }} {{ labels_errori.neonati }}
        </p>
        <br />
      </div>
      <div
        v-if="
          errori[0] != undefined &&
          errori[0].errore_generale != '' &&
          errori[0].errore_generale != 'anni_non_coincidenti'
        "
      >
        <p class="errore" id="errore-generale">
          {{ labels_errori[errori[0].errore_generale] }}
        </p>
        <br />
      </div>

      <p class="errore" style="text-align: center" v-if="errori_presenti">
        {{ labels_errori.si_sono_verificati_degli_errori }}
      </p>

      <br />

      <b-row v-if="!riepilogo_dati && local_reservation.status == ''">
        <b-col cols="6" style="text-align: center">
          <b-button
            style="width: 100%"
            variant="warning"
            v-on:click="memorizzazione_provvisoria"
            >{{ labels.memorizzazione_provvisoria }}</b-button
          >
        </b-col>
        <b-col cols="6" style="text-align: center">
          <b-button
            style="width: 100%"
            variant="success"
            v-on:click="verifica"
            >{{ labels.verifica_dati }}</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="!riepilogo_dati && local_reservation.status != ''">
        <b-col style="text-align: center">
          <b-button
            style="width: 100%"
            variant="success"
            v-on:click="verifica"
            >{{ labels.verifica_dati }}</b-button
          >
        </b-col>
      </b-row>
      <b-row v-if="riepilogo_dati">
        <b-col sm="12" md="6" lg="6" xl="6" style="text-align: center">
          <b-button
            style="width: 100%"
            variant="warning"
            v-on:click="modifica"
            >{{ labels.modifica_dati }}</b-button
          >
        </b-col>
        <b-col sm="12" md="6" lg="6" xl="6" style="text-align: center">
          <b-button
            style="width: 100%"
            variant="success"
            v-if="riepilogo_dati"
            v-on:click="invia"
            :disabled="invio_in_corso"
            >{{ labels.conferma_inserimento }}</b-button
          >
        </b-col>
        <b-col></b-col>
      </b-row>

      <!--
      <transition name="slide">
        <b-form-row
          class="b-form-row"
          style="text-align:center;width:100%"
          v-if="dismissCountDown > 0"
        >
          <b-col sm="12" md="12" lg="12" xl="12" style="width: 100%">
            <br />
            <b-alert
              :show="dismissCountDown"
              dismissible
              fade
              variant="warning"
              @dismiss-count-down="countDownChanged"
            >{{ labels.memorizzazione_effettuata }}</b-alert>
          </b-col>
        </b-form-row>
      </transition>
      -->
    </div>
  </div>
</template>

<script>
import { utility } from "@/utility";
import Lingua from "@/components/Lingua";
const axios = require("axios");

const LINGUA_ITALIANA = "IT";
const LINGUA_INGLESE = "EN";
const LINGUA_TEDESCA = "DE";
const LINGUA_FRANCESE = "FR";

export default {
  name: "CheckIn",
  data() {
    return {
      isFetching: true,
      errori_presenti: false,
      riepilogo_dati: false,
      size: "sm",
      conferma_verifica: "",
      nome_file_logo: "",
      invio_in_corso: false,
      lingua_italiana: LINGUA_ITALIANA,
      lingua_inglese: LINGUA_INGLESE,
      lingua_tedesca: LINGUA_TEDESCA,
      lingua_francese: LINGUA_FRANCESE,
      labels: {},
      labels_errori: {},
      valori_sesso: [],
      valori_partecipazione_viaggio: [],
      tipi_documento: [],
      enti_rilascio: [],
      valori_privacy: [],
      local_reservation: {
        origine: "",
        reservation_code: "",
        codice_struttura: "",
        // Il campo codice_struttura_origine non è usato
        //        codice_struttura_origine: "",
        inizio_soggiorno: "",
        fine_soggiorno: "",
        numero_persone: 0,
        lingua: "",
        email: "",
        cellulare: "",
        presenza_viaggio: "",
        targa_auto1: "",
        targa_auto2: "",
        targa_auto3: "",
        privacy: "",
        consenso_messaggi_pubblicitari: "",

        id_conto: 0,
        persone: [],
      },
      countries: [],
      errori: [],
      lista_localita_residenza: [],
      lista_localita_rilascio: [],
      lista_localita_nascita: [],
      lista_indirizzi_residenza: [],
    };
  },
  components: {
    Lingua,
  },
  props: {
    reservation: Object,
  },
  mixins: [utility],
  watch: {
    "$store.state.Lingua"(Lingua) {
      fn_CambiaLingua(Lingua, this);
    },
  },
  computed: {
    riferimento_struttura() {
      let riferimento = "";

      riferimento = this.reservation.select_struttura.descrizione;
      if (this.reservation.select_struttura.indirizzo != "") {
        riferimento +=
          ", " + this.reservation.select_struttura.indirizzo.trim();
      }
      if (this.reservation.select_struttura.cap != "") {
        riferimento += " - " + this.reservation.select_struttura.cap.trim();
      }
      if (this.reservation.select_struttura.localita != "") {
        riferimento += " " + this.reservation.select_struttura.localita.trim();
      }
      if (this.reservation.select_struttura.provincia != "") {
        riferimento +=
          " (" + this.reservation.select_struttura.provincia.trim() + ")";
      }
      if (this.reservation.select_struttura.telefono != "") {
        riferimento +=
          " - Tel. " + this.reservation.select_struttura.telefono.trim();
      }
      return riferimento;
    },
  },
  methods: {
    verifica() {
      this.errori_presenti = !fn_ControllaDati(this);
      if (!this.errori_presenti) {
        this.riepilogo_dati = true;
        this.conferma_verifica = "";
      }
    },
    modifica() {
      this.riepilogo_dati = false;
    },
    memorizzazione_provvisoria() {
      if (this.local_reservation.reservation_code == "PRENOTAZIONE_DEMO") {
        this.$bvModal.msgBoxOk(this.labels.prenotazione_demo, {
          title: "Prenotazione demo",
        });

        return;
      }

      let me = this;
      let ServerURL = this.$store.state.ServerURL;
      this.errori.splice(0);
      this.errori_presenti = false;

      let parametri = {
        canale: "PROVVISORIA",
        reservation: this.local_reservation,
      };
      let parametri_json = JSON.stringify(parametri);

      fn_CambiaCursore("wait", this);
      this.invio_in_corso = true;

      axios({
        method: "post",
        url: ServerURL + "CheckIn/AggiornaCheckin",
        data: parametri_json,
      })
        .then(function (response) {
          me.invio_in_corso = false;
          fn_CambiaCursore("default", me);
          if (response.data.errore == 0) {
            //me.$root.$children[0].$refs.ApplicationAlert.show(
            //  me.labels.memorizzazione_effettuata
            //);

            me.$bvModal.msgBoxOk(me.labels.memorizzazione_effettuata, {
              title: me.labels.conferma_memorizzazione,
            });
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "DatiCheckIn-memorizzazione_provvisoria"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          me.invio_in_corso = false;
          fn_CambiaCursore("default", me);
          me.registraErrore(error, "DatiCheckIn-memorizzazione_provvisoria");
        });
    },
    invia() {
      let me = this;

      if (!fn_ControllaDati(this)) {
        return;
      }

      if (this.local_reservation.reservation_code == "PRENOTAZIONE_DEMO") {
        this.$bvModal.msgBoxOk(this.labels.prenotazione_demo, {
          title: "Prenotazione demo",
        });

        return;
      }

      this.$bvModal
        .msgBoxConfirm(this.labels.confermi_invio_dati, {
          title: this.labels.conferma_aggiornamento,
          size: "md",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "OK",
          cancelVariant: "warning",
          cancelTitle: "Annulla",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            let ServerURL = this.$store.state.ServerURL;
            if (this.canale != "BACKOFFICE") {
              this.local_reservation.lingua = this.$store.state.Lingua;
            }
            let parametri = {
              canale: this.canale,
              reservation: this.local_reservation,
            };
            let parametri_json = JSON.stringify(parametri);

            fn_CambiaCursore("wait", this);
            this.invio_in_corso = true;

            axios({
              method: "post",
              url: ServerURL + "CheckIn/AggiornaCheckin",
              data: parametri_json,
            })
              .then(function (response) {
                me.invio_in_corso = false;

                fn_CambiaCursore("default", me);
                if (response.data.errore == 0) {
                  if (response.data.oggetto.length > 0) {
                    me.errori.splice(0);

                    for (let i = 0; i < response.data.oggetto.length; i++) {
                      me.errori.splice(i, 1, response.data.oggetto[i]);
                    }

                    me.errori_presenti = false;
                    for (let i = 0; i < me.errori.length; i++) {
                      for (let value of Object.values(me.errori[i])) {
                        if (value != "") {
                          me.errori_presenti = true;
                          me.riepilogo_dati = false;
                          break;
                        }
                      }
                    }
                  } else {
                    me.$router.push({
                      name: "CheckInAggiornato",
                      params: {
                        canale: me.canale,
                        origine: me.local_reservation.origine,
                        struttura: me.local_reservation.codice_struttura,
                        descrizione_struttura: "",
                        indirizzo_email: me.local_reservation.email,
                        reservation_code: me.local_reservation.reservation_code,
                        nome_file_logo: me.nome_file_logo,
                      },
                    });
                  }
                } else if (response.data.errore == -2) {
                  me.registraErrore(response.data.esito, "DatiCheckIn-invia");
                } else {
                  me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
                    title: me.labels_errori.si_e_verificato_un_errore,
                    bodyClass: "errore",
                  });
                }
              })
              .catch(function (error) {
                me.invio_in_corso = false;
                fn_CambiaCursore("default", me);
                me.registraErrore(error, "DatiCheckIn-invia");
              });
          }
        })
        .catch((error) => {
          me.invio_in_corso = false;
          this.registraErrore(error, "DatiCheckIn-invia");
        });
    },
    localita_variata(tipo, index, termine) {
      let me = this;
      let ServerURL = this.$store.state.ServerURL;

      switch (tipo) {
        case "R":
          this.lista_localita_residenza.splice(0);
          break;
        case "N":
          this.lista_localita_nascita.splice(0);
          break;
        case "D":
          this.lista_localita_rilascio.splice(0);
          break;
        default:
          return;
      }

      if (termine.length < 2) {
        return;
      }
      let nazione_residenza =
        this.local_reservation.persone[index].nazione_residenza;
      if (nazione_residenza == null || nazione_residenza == "") {
        nazione_residenza = "IT";
      }
      if (nazione_residenza != "IT") {
        return;
      }
      let parametri = {
        term: termine,
      };

      let parametri_json = JSON.stringify(parametri);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/CompletaLocalita",
        //url: ServerURL + "CompletaLocalita.php?term=" + termine
        data: parametri_json,
      })
        .then(function (response) {
          // for (let i = 0; i < response.data.length; i++) {
          //   switch (tipo) {
          //     case "R":
          //       me.lista_localita_residenza.splice(
          //         i,
          //         1,
          //         response.data[i].citta
          //       );

          //       break;
          //     case "N":
          //       me.lista_localita_nascita.splice(i, 1, response.data[i].citta);
          //       break;
          //     case "D":
          //       me.lista_localita_rilascio.splice(i, 1, response.data[i].citta);
          //       break;
          //   }

          //   if (i > 8) {
          //     break;
          //   }
          // }
          if (response.data.errore == 0) {
            for (let i = 0; i < response.data.oggetto.length; i++) {
              switch (tipo) {
                case "R":
                  me.lista_localita_residenza.splice(
                    i,
                    1,
                    response.data.oggetto[i]
                  );

                  break;
                case "N":
                  me.lista_localita_nascita.splice(
                    i,
                    1,
                    response.data.oggetto[i]
                  );
                  break;
                case "D":
                  me.lista_localita_rilascio.splice(
                    i,
                    1,
                    response.data.oggetto[i]
                  );
                  break;
              }
            }
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "DatiCheckIn-localita_variata"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          me.registraErrore(error, "DatiCheckIn-localita_variata");
        });
    },
    indirizzo_variato(index) {
      let me = this;
      let citta = this.local_reservation.persone[index].localita_residenza;
      let termine = this.local_reservation.persone[index].indirizzo_residenza;
      let ServerURL = this.$store.state.ServerURL;

      this.lista_indirizzi_residenza.splice(0);

      if (citta == "") {
        return;
      }
      if (termine.length < 2) {
        return;
      }
      let nazione_residenza =
        this.local_reservation.persone[index].nazione_residenza;
      if (nazione_residenza == null || nazione_residenza == "") {
        nazione_residenza = "IT";
      }
      if (nazione_residenza != "IT") {
        return;
      }

      let parametri = {
        citta: citta,
        term: termine,
      };

      let parametri_json = JSON.stringify(parametri);

      axios({
        method: "post",
        url: ServerURL + "CheckIn/CompletaIndirizzo",
        data: parametri_json,
      })
        .then(function (response) {
          if (response.data.errore == 0) {
            for (let i = 0; i < response.data.oggetto.length; i++) {
              me.lista_indirizzi_residenza.splice(
                i,
                1,
                response.data.oggetto[i]
              );
            }
          } else if (response.data.errore == -2) {
            me.registraErrore(
              response.data.esito,
              "DatiCheckIn-indirizzo_variato"
            );
          } else {
            me.$bvModal.msgBoxOk(me.labels_errori[response.data.esito], {
              title: me.labels_errori.si_e_verificato_un_errore,
              bodyClass: "errore",
            });
          }
        })
        .catch(function (error) {
          me.registraErrore(error, "DatiCheckIn-indirizzo_variato");
        });
    },
  },
  created() {
    this.canale = this.reservation.canale;
    this.local_reservation = this.reservation.reservation;
    this.countries = this.reservation.countries;
    this.nome_file_logo = this.reservation.nome_file_logo;
    fn_CambiaLingua(this.$store.state.Lingua, this);

    this.isFetching = false;
  },
};

function fn_CambiaLingua(lingua, vm) {
  let labels_italiano = {
    inserire_i_dati_richiesti: "Inserire i dati richiesti",
    tutti_i_dati_sono_obbligatori: "(tutti i dati sono obbligatori)",
    controllare_i_dati_inseriti: "Controllare i dati inseriti",
    capofamiglia: "Capofamiglia",
    partecipante: "Partecipante",
    cognome: "Cognome",
    nome: "Nome",
    sesso: "Sesso",
    cittadinanza: "Cittadinanza",
    codice_fiscale: "Codice fiscale",
    nazione_residenza: "Nazione residenza",
    localita_residenza: "Città residenza",
    indirizzo_residenza: "Indirizzo residenza (via, piazza)",
    civico_residenza: "N. Civico",
    provincia_residenza: "Provincia",
    cap_residenza: "CAP",
    data_nascita: "Data di nascita",
    giorno_nascita: "Giorno",
    mese_nascita: "Mese",
    anno_nascita: "Anno",
    nazione_nascita: "Nazione di nascita",
    comune_nascita: "Luogo di nascita",
    provincia_nascita: "Provincia",
    partecipazione_viaggio: "Partecipazione viaggio",
    tipo_documento_identita: "Tipo documento di identità",
    ente_rilascio: "Ente di emissione documento",
    data_rilascio: "Data rilascio",
    giorno_rilascio: "Giorno",
    mese_rilascio: "Mese",
    anno_rilascio: "Anno",
    luogo_rilascio: "Luogo rilascio",
    numero_documento_identita: "N. documento identità",
    email: "Email",
    cellulare: "Cellulare",
    targa_auto1: "Targa auto 1",
    targa_auto2: "Targa auto 2",
    targa_auto3: "Targa auto 3",
    privacy: "Privacy",
    la_informiamo:
      "La informiamo che, ai sensi del D.Lgs. 196/2003 e dell'art. 13 Regolamento UE n. 2016/679 recanti disposizioni a tutela delle persone e di altri soggetti rispetto al trattamento dei dati personali, i dati da Lei forniti verranno utilizzati nel rispetto dei principi di correttezza, trasparenza e tutela della Sua riservatezza e dei Suoi diritti.",
    il_trattamento:
      "Il trattamento dei Suoi dati avverrà con modalità idonee a garantire la sicurezza e la riservatezza degli stessi. Si informa altresì che i dati da Lei forniti non verranno trasmessi né divulgati a soggetti terzi o privati, se non in forma aggregata e anonima. L'elenco dettagliato dei soggetti nominati responsabili del trattamento e dei terzi ai quali i Suoi dati potranno essere comunicati, Le sarà fornito da: ",
    quale_titolare:
      ", quale titolare del trattamento, a seguito di Sua espressa richiesta.",
    do_il_consenso: "Dò il consenso",
    non_do_il_consenso: "Non dò il consenso",
    i_suoi_dati:
      "I Suoi dati verranno trattati manualmente o con strumenti informatici/telematici per scopi promozionali, quali l’invio di materiali pubblicitari ed informativi, nonché per elaborare studi e ricerche statistiche e di mercato.",
    ricordiamo_ai_gentili_ospiti:
      "Ricordiamo ai gentili ospiti che, una volta confermati, i dati inseriti nel presente check-in online non sono modificabili. Nell'eventualità in cui fosse necessario modificare e/o correggere i dati inseriti, Vi preghiamo di contattarci al numero ",
    potrebbe_essere_applicato:
      " (potrebbe essere applicato un costo aggiuntivo).",
    confermo_che_i_dati_inseriti:
      "Confermo che i dati inseriti sono stati verificati e sono corretti ",
    memorizzazione_provvisoria: "Memorizzazione provvisoria",
    conferma_memorizzazione: "Conferma memorizzazione",
    memorizzazione_effettuata:
      "Memorizzazione provvisoria effettuata. Attenzione! I dati del check-in saranno considerati confermati solamente dopo la memorizzazione definitiva.",
    verifica_dati: "Vai a verifica dati",
    modifica_dati: "Torna a modificare i dati",
    conferma_inserimento: "Invio dei dati inseriti",
    confermi_invio_dati: "Confermi l'invio dei dati ?",
    conferma_aggiornamento: "Conferma aggiornamento",
    numero_prenotazione: "N. Prenotazione",
    periodo_soggiorno: "Periodo soggiorno",
    inizio_soggiorno: "Data di inizio soggiorno",
    fine_soggiorno: "Data di fine soggiorno",
    prenotazione_demo:
      "Grazie per aver utilizzato Facile Check-in. La prenotazione che si sta memorizzando è una prenotazione dimostrativa e pertanto i dati non verranno effettivamente memorizzati.",
  };
  let labels_inglese = {
    inserire_i_dati_richiesti: "Enter the requested data",
    tutti_i_dati_sono_obbligatori: "(all data are required)",
    controllare_i_dati_inseriti: "Check entered data",
    capofamiglia: "Family Head",
    partecipante: "Participant",
    cognome: "Surname",
    nome: "Name",
    sesso: "Sex",
    cittadinanza: "Citizenship",
    codice_fiscale: "Fiscal code",
    nazione_residenza: "Country of residence",
    localita_residenza: "City of residence",
    indirizzo_residenza: "Residence address (street, square)",
    civico_residenza: "House number",
    provincia_residenza: "County",
    cap_residenza: "ZIP code",
    data_nascita: "Date of birth",
    giorno_nascita: "Day",
    mese_nascita: "Month",
    anno_nascita: "Year",
    nazione_nascita: "Nation of birth",
    comune_nascita: "Birth place",
    provincia_nascita: "County",
    partecipazione_viaggio: "Participation in the trip",
    tipo_documento_identita: "Identity Document type",
    ente_rilascio: "Document issuing authority",
    data_rilascio: "Release date",
    giorno_rilascio: "Day",
    mese_rilascio: "Month",
    anno_rilascio: "Year",
    luogo_rilascio: "Place of release",
    numero_documento_identita: "Identity Document No.",
    email: "Email",
    cellulare: "Mobile phone",
    targa_auto1: "Car 1 license plate",
    targa_auto2: "Car 2 license plate",
    targa_auto3: "Car 3 license plate",
    privacy: "Privacy",
    la_informiamo:
      "We inform you that, pursuant to Legislative Decree n. 196/2003 and of the EU Regulation n. 2016/679 containing provisions for the protection of persons and other subjects regarding the processing of personal data, the data you provide will be used in compliance with the principles of correctness, transparency and protection of your privacy and your rights.",
    il_trattamento:
      "Your data will be processed in a manner that guarantees the security and confidentiality of the same. We also inform you that the data you provide will not be transmitted or disclosed to third parties or individuals, except in aggregate and anonymous form. The detailed list of the persons appointed as data processors and third parties to whom your data may be communicated will be provided by: ",
    quale_titolare: ", as data controller, following your express request.",
    do_il_consenso: "I agree",
    non_do_il_consenso: "I don't agree",
    i_suoi_dati:
      "Your data will be processed manually or using IT / telematic tools for promotional purposes, such as sending advertising and information materials, as well as to carry out studies and statistical and market research.",
    ricordiamo_ai_gentili_ospiti:
      "We remind our guests that, once confirmed, the data entered in this online check-in cannot be changed. In the event that it is necessary to modify and/or correct the data entered, please contact us at ",
    potrebbe_essere_applicato: " (an additional cost may apply).",
    confermo_che_i_dati_inseriti:
      "I confirm that the data entered have been verified and are correct",
    memorizzazione_provvisoria: "Provisional archiving",
    conferma_memorizzazione: "Archiving confirmed",
    memorizzazione_effettuata:
      "Provisional archiving carried out. Attention! The check-in data will only be considered confirmed after final archiving.",
    verifica_dati: "Go to data verification",
    modifica_dati: "Back to edit data",
    conferma_inserimento: "Send entered data",
    confermi_invio_dati: "Do you confirm sending data?",
    conferma_aggiornamento: "Update confirmation",
    numero_prenotazione: "Reservation number",
    periodo_soggiorno: "Period of stay",
    inizio_soggiorno: "Start of stay date",
    fine_soggiorno: "End of stay date",
    prenotazione_demo:
      "Thank you for using Facile Check-in. The booking you are storing is a demonstration booking and therefore the data will not actually be stored.",
  };
  let labels_tedesco = {
    inserire_i_dati_richiesti: "Geben Sie die gewünschten Daten ein",
    tutti_i_dati_sono_obbligatori: "(alle Daten sind erforderlich)",
    controllare_i_dati_inseriti: "Überprüfen Sie die eingegebenen Daten",
    capofamiglia: "Familienoberhaupt",
    partecipante: "Teilnehmer",
    cognome: "Nachname",
    nome: "Vorname",
    sesso: "Sex",
    cittadinanza: "Staatsbürgerschaft",
    codice_fiscale: "Steuerkennzeichen",
    nazione_residenza: "Wohnsitz Nation",
    localita_residenza: "Wohnort",
    indirizzo_residenza: "Adresse des Wohnsitzes (Straße, Platz)",
    civico_residenza: "Hausnummer",
    provincia_residenza: "Provinz",
    cap_residenza: "Postleitzahl",
    data_nascita: "Datum geburt",
    giorno_nascita: "Tag",
    mese_nascita: "Monat",
    anno_nascita: "Jahr",
    nazione_nascita: "Nation der Geburt",
    comune_nascita: "Geburtsort",
    provincia_nascita: "Provinz",
    partecipazione_viaggio: "Teilnahme an der Reise",
    tipo_documento_identita: "Art des Ausweises",
    ente_rilascio: "Dokument ausstellende Stelle",
    data_rilascio: "Erscheinungsdatum",
    giorno_rilascio: "Tag",
    mese_rilascio: "Monat",
    anno_rilascio: "Jahr",
    luogo_rilascio: "Ort der Freilassung",
    numero_documento_identita: "Personalausweis Nr.",
    email: "Email",
    cellulare: "Zellular",
    targa_auto1: "Autokennzeichen 1",
    targa_auto2: "Autokennzeichen 2",
    targa_auto3: "Autokennzeichen 3",
    privacy: "Privacy",
    la_informiamo:
      "Wir informieren Sie, dass gemäß Gesetzesdekret n. 196/2003 und der EU-Verordnung n. 2016/679 enthält Bestimmungen zum Schutz von Personen und anderen Personen bei der Verarbeitung personenbezogener Daten. Die von Ihnen angegebenen Daten werden in Übereinstimmung mit den Grundsätzen der Korrektheit, Transparenz und des Schutzes Ihrer Privatsphäre und Ihrer Rechte verwendet.",
    il_trattamento:
      "Ihre Daten werden so verarbeitet, dass deren Sicherheit und Vertraulichkeit gewährleistet ist. Wir weisen Sie auch darauf hin, dass die von Ihnen angegebenen Daten nicht an Dritte oder Personen weitergegeben werden, außer in aggregierter und anonymer Form. Die detaillierte Liste der Personen, die als Datenverarbeiter und Dritte benannt wurden, an die Ihre Daten übermittelt werden dürfen, erhalten Sie von: ",
    quale_titolare: ", als Datenkontrolleur auf ausdrücklichen Wunsch.",
    do_il_consenso: "Ich gebe meine Zustimmung",
    non_do_il_consenso: "Ich gebe keine Zustimmung",
    i_suoi_dati:
      "Ihre Daten werden manuell oder mithilfe von Computer- / elektronischen Tools für Werbezwecke wie das Versenden von Werbe- und Informationsmaterialien sowie für die Durchführung von Studien sowie für statistische und Marktforschungszwecke verarbeitet.",
    ricordiamo_ai_gentili_ospiti:
      "Wir erinnern unsere Gäste daran, dass die bei diesem Online-Check-in eingegebenen Daten nach der Bestätigung nicht mehr geändert werden können. Für den Fall, dass eine Änderung und/oder Korrektur der eingegebenen Daten erforderlich ist, kontaktieren Sie uns bitte unter ",
    potrebbe_essere_applicato: " (zusätzliche Kosten können anfallen).",
    confermo_che_i_dati_inseriti:
      "Ich bestätige, dass die eingegebenen Daten überprüft wurden und korrekt sind ",
    memorizzazione_provvisoria: "Provisorische Archvierung",
    conferma_memorizzazione: "Archivierung bestätigt",
    memorizzazione_effettuata:
      "Provisorische Archivierung durchgeführt. Achtung! Die Eincheckdaten gelten erst nach der endgültigen Archivierung als bestätigt.",
    verifica_dati: "Gehen Sie zur Datenüberprüfung",
    modifica_dati: "Zurück zum Bearbeiten von Daten",
    conferma_inserimento: "Die eingegebenen Daten senden",
    confermi_invio_dati: "Bestätigen Sie das Senden der Daten ?",
    conferma_aggiornamento: "Update-Bestätigung",
    numero_prenotazione: "Reservierungsnummer",
    periodo_soggiorno: "Aufenthaltsdauer",
    inizio_soggiorno: "Startdatum des Aufenthalts",
    fine_soggiorno: "Enddatum des Aufenthalts",
    prenotazione_demo:
      "Vielen Dank, dass Sie Facile Check-in nutzen. Die Buchung, die Sie speichern, ist eine Demonstrationsbuchung und daher werden die Daten nicht tatsächlich gespeichert.",
  };
  let labels_francese = {
    inserire_i_dati_richiesti: "Enter the requested data",
    tutti_i_dati_sono_obbligatori: "(all data are required)",
    controllare_i_dati_inseriti: "Check entered data",
    capofamiglia: "Family Head",
    partecipante: "Participant",
    cognome: "Surname",
    nome: "Name",
    sesso: "Sex",
    cittadinanza: "Citizenship",
    codice_fiscale: "Fiscal code",
    nazione_residenza: "Country of residence",
    localita_residenza: "City of residence",
    indirizzo_residenza: "Residence address (street, square)",
    civico_residenza: "House number",
    provincia_residenza: "County",
    cap_residenza: "ZIP code",
    data_nascita: "Date of birth",
    giorno_nascita: "Day",
    mese_nascita: "Month",
    anno_nascita: "Year",
    nazione_nascita: "Nation of birth",
    comune_nascita: "Birth place",
    provincia_nascita: "County of birth",
    partecipazione_viaggio: "Participation in the trip",
    tipo_documento_identita: "Identity Document type",
    ente_rilascio: "Document issuing authority",
    data_rilascio: "Release date",
    giorno_rilascio: "Day",
    mese_rilascio: "Month",
    anno_rilascio: "Year",
    luogo_rilascio: "Place of release",
    numero_documento_identita: "Identity Document No.",
    email: "Email",
    cellulare: "Mobile phone",
    targa_auto1: "Car 1 license plate",
    targa_auto2: "Car 2 license plate",
    targa_auto3: "Car 3 license plate",
    privacy: "Privacy",
    la_informiamo:
      "We inform you that, pursuant to Legislative Decree n. 196/2003 and of the EU Regulation n. 2016/679 containing provisions for the protection of persons and other subjects regarding the processing of personal data, the data you provide will be used in compliance with the principles of correctness, transparency and protection of your privacy and your rights.",
    il_trattamento:
      "Your data will be processed in a manner that guarantees the security and confidentiality of the same. We also inform you that the data you provide will not be transmitted or disclosed to third parties or individuals, except in aggregate and anonymous form. The detailed list of the persons appointed as data processors and third parties to whom your data may be communicated will be provided by: ",
    quale_titolare: ", as data controller, following your express request.",
    do_il_consenso: "I agree",
    non_do_il_consenso: "I don't agree",
    i_suoi_dati:
      "Your data will be processed manually or using IT / telematic tools for promotional purposes, such as sending advertising and information materials, as well as to carry out studies and statistical and market research.",
    ricordiamo_ai_gentili_ospiti:
      "We remind our guests that, once confirmed, the data entered in this online check-in cannot be changed. In the event that it is necessary to modify and/or correct the data entered, please contact us at ",
    potrebbe_essere_applicato: " (an additional cost may apply).",
    confermo_che_i_dati_inseriti:
      "I confirm that the data entered have been verified and are correct",
    memorizzazione_provvisoria: "Temporary storage",
    conferma_memorizzazione: "Conferma memorizzazione",
    memorizzazione_effettuata:
      "Memorizzazione provvisoria effettuata. Attenzione! I dati del check-in saranno considerati inseriti, solo deopo che tutti i dati siano stati compilati e confermati. ",
    verifica_dati: "Go to data verification",
    modifica_dati: "Back to edit data",
    conferma_inserimento: "Send entered data",
    confermi_invio_dati: "Do you confirm sending data?",
    conferma_aggiornamento: "Update confirmation",
    numero_prenotazione: "Reservation number",
    periodo_soggiorno: "Period of stay",
    inizio_soggiorno: "Start of stay date",
    fine_soggiorno: "End of stay date",
    prenotazione_demo:
      "Thank you for using Facile Check-in. The booking you are storing is a demonstration booking and therefore the data will not actually be stored.",
  };

  let labels_errori_italiano = {
    si_sono_verificati_degli_errori: "Si sono verificati degli errori.",
    si_e_verificato_un_errore: "Si è verificato un errore",
    dato_obbligatorio: "Dato obbligatorio",
    codice_fiscale_errato: "Codice fiscale errato",
    citta_errata: "Città errata",
    provincia_errata: "Provincia errata",
    indirizzo_errato: "Indirizzo errato",
    cap_errato: "CAP errato",
    giorno_errato: "Giorno errato",
    mese_errato: "Mese errato",
    struttura_non_trovata: "Struttura non trovata",
    indirizzo_email_non_valido: "Indirizzo email non valido",
    indicare_email_o_cellulare:
      "E' necessario indicare l'indirizzo email oppure il numero di cellulare",
    consenso_obbligatorio:
      "Il consenso al trattamento dei dati personali è necessario per poter continuare l'elaborazione.",
    data_errata: "Data errata",
    primo_partecipante_non_adulto:
      "Il primo partecipante deve essere un adulto",
    anni_non_coincidenti:
      "Le date di nascita non coincidono con il numero di adulti/bambini/neonati previsto",
    adulti: "adulti",
    bambini: "bambini",
    neonati: "neonati",
  };
  let labels_errori_inglese = {
    si_sono_verificati_degli_errori: "There have been errors",
    si_e_verificato_un_errore: "an error has occurred",
    dato_obbligatorio: "Required field",
    codice_fiscale_errato: "Wrong fiscal code",
    citta_errata: "Wrong City",
    provincia_errata: "Wrong county",
    indirizzo_errato: "Wrong address",
    cap_errato: "Wrong ZIP code",
    giorno_errato: "Wrong day",
    mese_errato: "Wrong month",
    struttura_non_trovata: "Facility not found",
    indirizzo_email_non_valido: "The email address is not valid.",
    indicare_email_o_cellulare:
      "E-mail address or mobile phone number is required",
    consenso_obbligatorio:
      "The consent to the processing of personal data is required in order to proceed.",
    data_errata: "Wrong date",
    primo_partecipante_non_adulto: "The first participant is not an adult.",
    anni_non_coincidenti:
      "The dates of birth entered do not match the number of adults/children/infants in the booking",
    adulti: "adults",
    bambini: "children",
    neonati: "infants",
  };
  let labels_errori_tedesco = {
    si_sono_verificati_degli_errori: "Es sind Fehler aufgetreten.",
    si_e_verificato_un_errore: "Ein Fehler ist aufgetreten",
    dato_obbligatorio: "Erforderliches Feld",
    codice_fiscale_errato: "Falsche Steuerkennzeichen",
    citta_errata: "Falsche Stadt",
    provincia_errata: "Falsche Provinz",
    indirizzo_errato: "Falsche Adresse",
    cap_errato: "Falsche Postleitzahl",
    giorno_errato: "Falscher Tag",
    mese_errato: "Falscher Monat",
    struttura_non_trovata: "Einrichtung nicht gefunden",
    indirizzo_email_non_valido: "Die E-Mail-Adresse ist nicht gültig.",
    indicare_email_o_cellulare:
      "E-Mail-Adresse oder Handynummer ist erforderlich",
    consenso_obbligatorio:
      "Die Einwilligung zur Verarbeitung personenbezogener Daten ist Voraussetzung für den Fortgang.",
    data_errata: "Falsches datum",
    primo_partecipante_non_adulto: "Der erste Teilnehmer ist kein Erwachsener.",
    anni_non_coincidenti:
      "Die eingegebenen Geburtsdaten stimmen nicht mit der Anzahl der Erwachsenen/Kinder/Kleinkinder in der Buchung überein",
    adulti: "Erwachsenen",
    bambini: "Kinder",
    neonati: "Kleinkinder",
  };
  let labels_errori_francese = {
    si_sono_verificati_degli_errori: "There have been errors",
    si_e_verificato_un_errore: "an error has occurred",
    dato_obbligatorio: "Required field",
    codice_fiscale_errato: "Wrong fiscal code",
    citta_errata: "Wrong City",
    provincia_errata: "Wrong county",
    indirizzo_errato: "Wrong address",
    cap_errato: "Wrong ZIP code",
    giorno_errato: "Wrong day",
    mese_errato: "Wrong month",
    struttura_non_trovata: "Facility not found",
    indirizzo_email_non_valido: "The email address is not valid.",
    indicare_email_o_cellulare:
      "E-mail address or mobile phone number is required",
    consenso_obbligatorio:
      "The consent to the processing of personal data is mandatory in order to proceed.",
    data_errata: "Wrong date",
    primo_partecipante_non_adulto: "The first participant is not an adult.",
    anni_non_coincidenti:
      "The dates of birth entered do not match the number of adults/children/infants in the booking",
    adulti: "adults",
    bambini: "children",
    neonati: "infants",
  };

  let valori_sesso_italiano = [
    { text: "Maschio", value: "M" },
    { text: "Femmina", value: "F" },
  ];
  let valori_sesso_inglese = [
    { value: "M", text: "Male" },
    { value: "F", text: "Female" },
  ];
  let valori_sesso_tedesco = [
    { text: "Männlich ", value: "M" },
    { text: "Weiblich", value: "F" },
  ];
  let valori_sesso_francese = [
    { value: "M", text: "Male" },
    { value: "F", text: "Female" },
  ];

  let valori_partecipazione_viaggio_italiano = [
    { value: "", text: "" },
    { value: "E", text: "Andata e ritorno" },
    { value: "A", text: "Solo andata" },
    { value: "R", text: "Solo ritorno" },
    { value: "N", text: "Nessun viaggio" },
  ];
  let valori_partecipazione_viaggio_inglese = [
    { value: "", text: "" },
    { value: "E", text: "Roundtrip" },
    { value: "A", text: "One way" },
    { value: "R", text: "Only return" },
    { value: "N", text: "No trip" },
  ];
  let valori_partecipazione_viaggio_tedesco = [
    { value: "", text: "" },
    { value: "E", text: "Rundreise" },
    { value: "A", text: "Ein Weg" },
    { value: "R", text: "Nur Rückkehr" },
    { value: "N", text: "Keine Reise" },
  ];
  let valori_partecipazione_viaggio_francese = [
    { value: "", text: "" },
    { value: "E", text: "Roundtrip" },
    { value: "A", text: "One way" },
    { value: "R", text: "Only return" },
    { value: "N", text: "No trip" },
  ];

  let tipi_documento_italiano = [
    { value: "C", text: "CARTA D'IDENTITA'" },
    { value: "P", text: "PASSAPORTO" },
  ];
  let tipi_documento_inglese = [
    { value: "C", text: "ID CARD" },
    { value: "P", text: "PASSPORT" },
  ];
  let tipi_documento_tedesco = [
    { value: "C", text: "IDENTITÄTSKARTE" },
    { value: "P", text: "PAß" },
  ];
  let tipi_documento_francese = [
    { value: "C", text: "ID CARD" },
    { value: "P", text: "PASSPORT" },
  ];

  let enti_rilascio_italiano = [
    { value: "1", text: "AMBASCIATA" },
    { value: "2", text: "COMUNE" },
    { value: "3", text: "CONSOLATO" },
    { value: "4", text: "ENTE DI STATO" },
    { value: "5", text: "MINISTERO" },
    { value: "6", text: "MOTORIZZAZIONE CIV." },
    { value: "7", text: "PREFETTURA" },
    { value: "8", text: "QUESTURA" },
    { value: "9", text: "UFFICIO PASSAPORTI" },
  ];
  let enti_rilascio_inglese = [
    { value: "1", text: "EMBASSY" },
    { value: "2", text: "MUNICIPALITY" },
    { value: "3", text: "CONSULATE" },
    { value: "4", text: "STATE INSTITUTION" },
    { value: "5", text: "MINISTRY" },
    { value: "6", text: "VEHICLE REGISTRATION" },
    { value: "7", text: "PREFECTURE" },
    { value: "8", text: "POLICE HEADQUARTERS" },
    { value: "9", text: "PASSPORTS OFFICE" },
  ];
  let enti_rilascio_tedesco = [
    { value: "1", text: "EMBASSY" },
    { value: "2", text: "GEMEINDE" },
    { value: "3", text: "KONSULAT" },
    { value: "4", text: "STAATLICHE INSTITUTION" },
    { value: "5", text: "MINISTERIUM" },
    { value: "6", text: "ZIVILMOTORISIERUNG" },
    { value: "7", text: "PRÄFEKTUR" },
    { value: "8", text: "POLIZEIPRÄSIDIUM" },
    { value: "9", text: "PASSBÜRO" },
  ];
  let enti_rilascio_francese = [
    { value: "1", text: "EMBASSY" },
    { value: "2", text: "MUNICIPALITY" },
    { value: "3", text: "CONSULATE" },
    { value: "4", text: "STATE INSTITUTION" },
    { value: "5", text: "MINISTRY" },
    { value: "6", text: "VEHICLE REGISTRATION" },
    { value: "7", text: "PREFECTURE" },
    { value: "8", text: "POLICE HEADQUARTERS" },
    { value: "9", text: "PASSPORTS OFFICE" },
  ];

  let valori_privacy_italiano = [
    { value: "S", text: "Dò il consenso" },
    { value: "N", text: "Non dò il consenso" },
  ];
  let valori_privacy_inglese = [
    { value: "S", text: "I agree" },
    { value: "N", text: "I don't agree" },
  ];
  let valori_privacy_tedesco = [
    { value: "S", text: "Ich gebe meine Zustimmung" },
    { value: "N", text: "Ich gebe keine Zustimmung" },
  ];
  let valori_privacy_francese = [
    { value: "S", text: "I agree" },
    { value: "N", text: "I don't agree" },
  ];

  vm.valori_sesso.length = 0;
  vm.valori_partecipazione_viaggio.length = 0;
  vm.tipi_documento.length = 0;
  vm.enti_rilascio.length = 0;
  vm.valori_privacy.length = 0;

  switch (lingua) {
    case LINGUA_ITALIANA:
      vm.labels = labels_italiano;
      vm.labels_errori = labels_errori_italiano;
      vm.valori_sesso = valori_sesso_italiano;
      vm.valori_partecipazione_viaggio = valori_partecipazione_viaggio_italiano;
      vm.tipi_documento = tipi_documento_italiano;
      vm.enti_rilascio = enti_rilascio_italiano;
      vm.valori_privacy = valori_privacy_italiano;
      break;
    case LINGUA_INGLESE:
      vm.labels = labels_inglese;
      vm.labels_errori = labels_errori_inglese;
      vm.valori_sesso = valori_sesso_inglese;
      vm.valori_partecipazione_viaggio = valori_partecipazione_viaggio_inglese;
      vm.tipi_documento = tipi_documento_inglese;
      vm.enti_rilascio = enti_rilascio_inglese;
      vm.valori_privacy = valori_privacy_inglese;
      break;
    case LINGUA_TEDESCA:
      vm.labels = labels_tedesco;
      vm.labels_errori = labels_errori_tedesco;
      vm.valori_sesso = valori_sesso_tedesco;
      vm.valori_partecipazione_viaggio = valori_partecipazione_viaggio_tedesco;
      vm.tipi_documento = tipi_documento_tedesco;
      vm.enti_rilascio = enti_rilascio_tedesco;
      vm.valori_privacy = valori_privacy_tedesco;
      break;
    case LINGUA_FRANCESE:
      vm.labels = labels_francese;
      vm.labels_errori = labels_errori_francese;
      vm.valori_sesso = valori_sesso_francese;
      vm.valori_partecipazione_viaggio = valori_partecipazione_viaggio_francese;
      vm.tipi_documento = tipi_documento_francese;
      vm.enti_rilascio = enti_rilascio_francese;
      vm.valori_privacy = valori_privacy_francese;
      break;
    default:
      vm.labels = labels_inglese;
      vm.labels_errori = labels_errori_inglese;
      vm.valori_sesso = valori_sesso_inglese;
      vm.valori_partecipazione_viaggio = valori_partecipazione_viaggio_inglese;
      vm.tipi_documento = tipi_documento_inglese;
      vm.enti_rilascio = enti_rilascio_inglese;
      vm.valori_privacy = valori_privacy_inglese;
      break;
  }
}

function fn_ControllaDati(vm) {
  try {
    let esito = true;
    vm.errori.splice(0);

    for (let i = 0; i < vm.local_reservation.persone.length; i++) {
      let persona = vm.local_reservation.persone[i];

      let nuovo_errore = {};

      if (i == 0) {
        nuovo_errore.email = "";

        if (vm.local_reservation.email.trim() == "") {
          esito = false;
          nuovo_errore.email = "dato_obbligatorio";
        } else {
          let pattern = vm.$store.state.PatternEmail;

          if (!pattern.test(vm.local_reservation.email)) {
            esito = false;
            nuovo_errore.email = "indirizzo_email_non_valido";
          }
        }

        nuovo_errore.cellulare = "";
        // if (vm.local_reservation.cellulare.trim() == "") {
        //   esito = false;
        //   nuovo_errore.cellulare = "dato_obbligatorio";
        // }
        nuovo_errore.privacy = "";
        if (vm.local_reservation.privacy.trim() == "") {
          esito = false;
          nuovo_errore.privacy = "dato_obbligatorio";
        } else {
          if (vm.local_reservation.privacy.trim() != "S") {
            esito = false;
            nuovo_errore.privacy = "consenso_obbligatorio";
          }
        }
        nuovo_errore.consenso_messaggi_pubblicitari = "";
        if (vm.local_reservation.consenso_messaggi_pubblicitari.trim() == "") {
          esito = false;
          nuovo_errore.consenso_messaggi_pubblicitari = "dato_obbligatorio";
        }

        if (vm.riepilogo_dati) {
          nuovo_errore.conferma_verifica = "";
          if (vm.conferma_verifica.trim() == "") {
            esito = false;
            nuovo_errore.conferma_verifica = "dato_obbligatorio";
          }
        }
      }

      nuovo_errore.cognome = "";
      if (persona.cognome.trim() == "") {
        esito = false;
        nuovo_errore.cognome = "dato_obbligatorio";
      }
      nuovo_errore.nome = "";
      if (persona.nome.trim() == "") {
        esito = false;
        nuovo_errore.nome = "dato_obbligatorio";
      }
      nuovo_errore.sesso = "";
      if (persona.sesso.trim() == "") {
        esito = false;
        nuovo_errore.sesso = "dato_obbligatorio";
      } else {
        if (persona.sesso.trim() != "M" && persona.sesso.trim() != "F") {
          esito = false;
          nuovo_errore.sesso = "dato_obbligatorio";
        }
      }
      nuovo_errore.cittadinanza = "";
      if (persona.cittadinanza.trim() == "") {
        esito = false;
        nuovo_errore.cittadinanza = "dato_obbligatorio";
      }
      nuovo_errore.codice_fiscale = "";
      if (persona.cittadinanza == "IT") {
        // if (persona.codice_fiscale.trim() == "") {
        //   esito = false;
        //   nuovo_errore.codice_fiscale = "dato_obbligatorio";
        // }
      }
      nuovo_errore.nazione_residenza = "";
      if (persona.nazione_residenza.trim() == "") {
        esito = false;
        nuovo_errore.nazione_residenza = "dato_obbligatorio";
      }
      nuovo_errore.localita_residenza = "";
      if (persona.localita_residenza.trim() == "") {
        esito = false;
        nuovo_errore.localita_residenza = "dato_obbligatorio";
      }
      nuovo_errore.indirizzo_residenza = "";
      if (persona.indirizzo_residenza.trim() == "") {
        esito = false;
        nuovo_errore.indirizzo_residenza = "dato_obbligatorio";
      }
      nuovo_errore.civico_residenza = "";
      if (persona.civico_residenza.trim() == "") {
        esito = false;
        nuovo_errore.civico_residenza = "dato_obbligatorio";
      }
      nuovo_errore.provincia_residenza = "";
      if (persona.nazione_residenza == "IT") {
        if (persona.provincia_residenza.trim() == "") {
          esito = false;
          nuovo_errore.provincia_residenza = "dato_obbligatorio";
        }
      }
      nuovo_errore.cap_residenza = "";
      if (persona.cap_residenza.trim() == "") {
        esito = false;
        nuovo_errore.cap_residenza = "dato_obbligatorio";
      }
      nuovo_errore.giorno_nascita = "";
      if (persona.giorno_nascita.trim() == "") {
        esito = false;
        nuovo_errore.giorno_nascita = "dato_obbligatorio";
      }
      nuovo_errore.mese_nascita = "";
      if (persona.mese_nascita.trim() == "") {
        esito = false;
        nuovo_errore.giorno_nascita = "dato_obbligatorio";
      }
      nuovo_errore.anno_nascita = "";
      if (persona.anno_nascita.trim() == "") {
        esito = false;
        nuovo_errore.giorno_nascita = "dato_obbligatorio";
      }
      if (
        !vm.verificaData(
          persona.giorno_nascita,
          persona.mese_nascita,
          persona.anno_nascita
        )
      ) {
        esito = false;
        nuovo_errore.giorno_nascita = "data_errata";
      }

      nuovo_errore.nazione_nascita = "";
      if (persona.nazione_nascita.trim() == "") {
        esito = false;
        nuovo_errore.nazione_nascita = "dato_obbligatorio";
      }
      nuovo_errore.comune_nascita = "";
      if (persona.comune_nascita.trim() == "") {
        esito = false;
        nuovo_errore.comune_nascita = "dato_obbligatorio";
      }
      nuovo_errore.provincia_nascita = "";
      if (persona.nazione_nascita == "IT") {
        if (persona.provincia_nascita.trim() == "") {
          esito = false;
          nuovo_errore.provincia_nascita = "dato_obbligatorio";
        }
      }

      if (vm.local_reservation.presenza_viaggio == "S") {
        nuovo_errore.partecipazione_viaggio = "";
        if (persona.partecipazione_viaggio.trim() == "") {
          esito = false;
          nuovo_errore.partecipazione_viaggio = "dato_obbligatorio";
        }
      }
      nuovo_errore.tipo_documento_identita = "";
      if (persona.tipo_documento_identita.trim() == "") {
        esito = false;
        nuovo_errore.tipo_documento_identita = "dato_obbligatorio";
      }
      nuovo_errore.ente_rilascio = "";
      if (persona.ente_rilascio.trim() == "") {
        esito = false;
        nuovo_errore.ente_rilascio = "dato_obbligatorio";
      }
      nuovo_errore.giorno_rilascio = "";
      if (persona.giorno_rilascio.trim() == "") {
        esito = false;
        nuovo_errore.giorno_rilascio = "dato_obbligatorio";
      }
      nuovo_errore.mese_rilascio = "";
      if (persona.mese_rilascio.trim() == "") {
        esito = false;
        nuovo_errore.giorno_rilascio = "dato_obbligatorio";
      }
      nuovo_errore.anno_rilascio = "";
      if (persona.anno_rilascio.trim() == "") {
        esito = false;
        nuovo_errore.giorno_rilascio = "dato_obbligatorio";
      }
      if (
        !vm.verificaData(
          persona.giorno_rilascio,
          persona.mese_rilascio,
          persona.anno_rilascio
        )
      ) {
        esito = false;
        nuovo_errore.giorno_rilascio = "data_errata";
      }
      nuovo_errore.luogo_rilascio = "";
      if (persona.luogo_rilascio.trim() == "") {
        esito = false;
        nuovo_errore.luogo_rilascio = "dato_obbligatorio";
      }

      nuovo_errore.numero_documento_identita = "";
      if (persona.numero_documento_identita.trim() == "") {
        esito = false;
        nuovo_errore.numero_documento_identita = "dato_obbligatorio";
      }

      vm.errori.splice(i, 1, nuovo_errore);
    }

    return esito;
  } catch (error) {
    vm.registraErrore(error, "DatiCheckIn-fn_ControllaDati");
  }
}

function fn_CambiaCursore(cursore, vm) {
  document.querySelector("body").style.cursor = cursore;

  if (cursore == "wait") {
    vm.invio_in_corso = true;
  } else {
    vm.invio_in_corso = false;
  }
}

// jQuery(document).ready(function () {

//         jQuery("*[id*=\"localita_residenza\"]").autocomplete(
//         {
//             source: "/Home/CompletaLocalita",
//             minLength: 2,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" },
//             select: function (event, ui) { }
//         });

//         jQuery("*[id*=\"provincia_residenza\"]").autocomplete(
//         {
//             source: "/Home/CompletaProvincia",
//             minLength: 1,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//         jQuery("*[id*=\"comune_nascita\"]").autocomplete(
//         {
//             source: "/Home/CompletaLocalita",
//             minLength: 2,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//         jQuery("*[id*=\"provincia_nascita\"]").autocomplete(
//         {
//             source: "/Home/CompletaProvincia",
//             minLength: 1,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//         jQuery("*[id*=\"luogo_rilascio\"]").autocomplete(
//         {
//             source: "/Home/CompletaLocalita",
//             minLength: 2,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//         jQuery("*[id*=\"localita_residenza\"]").each(function (index, element) { fn_cambio_localita_residenza(element) });
//         jQuery("*[id*=\"comune_nascita\"]").each(function (index, element) { fn_cambio_comune_nascita(element) });
//         jQuery("*[id*=\"nazione_nascita\"]").each(function (index, element) { fn_toggle_nascita(element) });
//         jQuery("*[id*=\"nazione_residenza\"]").each(function (index, element) { fn_toggle_residenza(element) });
//         jQuery("*[id*=\"cittadinanza\"]").each(function (index, element) { fn_cambio_cittadinanza(element) });

//     });

//     function fn_toggle_nascita(item) {

//         var posizione = item.id.indexOf("nazione_nascita");
//         var prefisso = item.id.substring(0, posizione);

//         var capofamiglia = item.id.indexOf("0");

//     }

//     function fn_toggle_residenza(item) {

//         var posizione = item.id.indexOf("nazione_residenza");
//         var prefisso = item.id.substring(0, posizione);

//         var capofamiglia = item.id.indexOf("0");
//     }

//     function fn_cambio_localita_residenza(item) {
//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("localita_residenza", "indirizzo_residenza");
//         var indirizzo = $("#" + nome_campo).val();

//         fn_autocomplete_indirizzo_residenza(nome_campo, item.value);

//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("localita_residenza", "provincia_residenza");
//         fn_autocomplete_provincia_residenza(nome_campo, item.value, indirizzo);

//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("localita_residenza", "cap_residenza");
//         fn_leggi_cap(nome_campo);
//     }

//     function fn_cambio_indirizzo_residenza(item) {
//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("indirizzo_residenza", "localita_residenza");
//         var localita = $("#" + nome_campo).val();

//         fn_autocomplete_provincia_residenza(localita, item.value);

//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("indirizzo_residenza", "cap_residenza");
//         fn_leggi_cap(nome_campo);
//     }

//     function fn_cambio_provincia_residenza(item) {

//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("provincia_residenza", "cap_residenza");
//         fn_leggi_cap(nome_campo);
//     }

//     function fn_cambio_comune_nascita(item) {
//         var nome_campo = item.id.toString();
//         nome_campo = nome_campo.replace("comune_nascita", "provincia_nascita");
//         fn_autocomplete_provincia_nascita(nome_campo, item.value);
//     }

//     function fn_cambio_cittadinanza(item) {
//         var posizione = item.id.indexOf("cittadinanza");
//         var prefisso = item.id.substring(0, posizione);

//         if ($(item).val() == "IT") {
//             $("label[for=\"" + prefisso + "codice_fiscale" + "\"]").show();
//             $("#" + prefisso + "codice_fiscale").show();
//         }
//         else {
//             $("label[for=\"" + prefisso + "codice_fiscale" + "\"]").hide();
//             $("#" + prefisso + "codice_fiscale").hide();
//         }
//     }

//     function fn_autocomplete_indirizzo_residenza(item, localita) {

//         jQuery("#" + item).autocomplete(
//         {
//             source: "/Home/CompletaIndirizzo?nazione=IT&citta=" + localita + "&",
//             minLength: 2,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });
//     }

//     function fn_autocomplete_provincia_residenza(item, localita, indirizzo) {

//         var source = "/Home/CompletaProvincia?citta=" + localita + "&indirizzo=" + indirizzo + "&";

//         jQuery("#" + item).autocomplete(
//         {
//             source: source,
//             minLength: 1,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//     }

//     function fn_autocomplete_provincia_nascita(item, localita) {

//         var source = "/Home/CompletaProvincia?citta=" + localita + "&indirizzo=&";

//         jQuery("#" + item).autocomplete(
//         {
//             source: source,
//             minLength: 1,
//             delay: 100,
//             position: { my: "right bottom", at: "right top" }
//         });

//     }

//     function fn_leggi_cap(campo) {

//         var nome_campo = campo.replace("cap_residenza", "nazione_residenza");
//         if ($("#" + nome_campo).val() != "IT") {
//             return;
//         }

//         var nome_campo = campo.replace("cap_residenza", "localita_residenza");
//         var citta = $("#" + nome_campo).val();

//         nome_campo = campo.replace("cap_residenza", "indirizzo_residenza");
//         var indirizzo = $("#" + nome_campo).val();

//         nome_campo = campo.replace("cap_residenza", "provincia_residenza");
//         var provincia= $("#" + nome_campo).val();

//         jQuery.ajax({
//             async: false,
//             type: "GET",
//             cache: false,
//             url: '/Home/LeggiCAP?citta=' + citta + "&indirizzo=" + indirizzo + "&provincia=" + provincia,
//             dataType: "text",
//             success: function (data, xhr, settings) {
//                 $("#" + campo).val(data);
//             },
//             error: function (xhr, textStatus, error) {
//                 alert(textStatus + ": " + error);
//             }
//         });
//     }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dati-checkin {
  padding: 20px 40px 30px 40px;
  background-color: aliceblue;
  border-radius: 4px;
}

.b-form-row {
  margin-bottom: 0px;
}

.justified {
  text-align: justify;
}

hr {
  border-top: 1px solid #eeeeee;
  border-bottom: 1px solid #ffffff;
  margin-left: -25px;
  margin-right: -25px;
}

.form-group {
  font-size: smaller;
}
</style>
